import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalRewardsComponent } from '../modal-rewards/modal-rewards.component';

@Component({
  selector: 'app-modal-discount-confirmation',
  templateUrl: './modal-discount-confirmation.component.html',
  styleUrls: ['./modal-discount-confirmation.component.css']
})
export class ModalDiscountConfirmationComponent implements OnInit {

  @Input()
  availableRewards: number;

  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal) {
  }

  ngOnInit() {
  }

  misRecompensas() {
    this.modalService.open(ModalRewardsComponent, { centered: true, windowClass: 'modal-reward' });
  }


  continuar() {
    this.activeModal.close(true);
  }

}
